import { handleRequest } from "../utilities/requestHandler";

export const getPriceMarkups = () => handleRequest("get", "/price-markup");

export const updatePriceMarkup = (id, payload) =>
	handleRequest("put", `/price-markup/${id}`, payload);
